import { render } from "./PointJournalierDesVentesPage.vue?vue&type=template&id=36817d54&ts=true"
import script from "./PointJournalierDesVentesPage.vue?vue&type=script&lang=ts"
export * from "./PointJournalierDesVentesPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__